import { Component, OnInit } from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DoraProperty} from '../../Decorators/Decorator';

@Component({
  selector: 'dora-collapse-expand',
  templateUrl: './dora-collapse-expand.component.html',
  styleUrls: ['./dora-collapse-expand.component.scss']
})
export class DoraCollapseExpandComponent extends WidgetBaseComponent {
  private text: string;
  private currentStatusExpanded: boolean;

  @DoraProperty
  private textExpanded = '';
  @DoraProperty
  private textCollapsed = '';

  @DoraProperty
  private initialStatusExpanded = true;

  @DoraProperty
  elementReferenceId = '';

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.currentStatusExpanded = this.initialStatusExpanded;
    this.updateValues();
  }

  private getContainerCssClass(): string {
    const result = 'DAG-container ' + (this.currentStatusExpanded === true ? 'expanded' : 'collapsed');
    return result;
  }
  private getContentCssClass(): string {
    const result = 'DAG-content ' + (this.currentStatusExpanded === true ? 'expanded' : 'collapsed');
    return result;
  }
  private onSelect(): void {
    this.currentStatusExpanded = !this.currentStatusExpanded;
    this.updateValues();
  }
  private updateValues(): void {
    if (this.currentStatusExpanded) {
      // this.text = this.textExpanded;
      this.text = this.translationService.get(this.textExpanded);

      document.getElementById(this.elementReferenceId).classList.remove('DAG-hide');
      document.getElementById(this.elementReferenceId).classList.add('DAG-show');
    } else {
      // this.text = this.textCollapsed;
      this.text = this.translationService.get(this.textCollapsed);

      document.getElementById(this.elementReferenceId).classList.remove('DAG-show');
      document.getElementById(this.elementReferenceId).classList.add('DAG-hide');
    }
  }
}
